// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2530": "e96a97f9","8795": "771c29ae","9464": "6f8a31c1","9578": "8c27974e",}[chunkId] + ".css"
}